import {
  changedUrlPath,
  setInitialUrl,
  setSearchParams
} from '../modules/url/actions'

export default store => next => action => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      // Want to make sure that the location has changed
      // before calling trackHistory
      next(action)

      trackHistory(store)
      break

    default:
      next(action)
  }
}

function clearUrlSearchParams () {
  const url = window.location.href

  window.history.replaceState({}, document.title,
    url.substring(0, url.indexOf('?')))
}

function trackPageView () {
  // Hubspot doesn't correctly attribute the page view
  let _hsq = window._hsq = window._hsq || []
  _hsq.push(['setPath', (window.location.pathname + window.location.search)])
  _hsq.push(['trackPageView'])
}

function trackHistory (store) {
  const state = store.getState().url

  // Track page view before any url stripping
  trackPageView()

  if (!state.landingUrl) {
    const landingUrl = window.location.href
    const searchParams = new URL(landingUrl).searchParams

    store.dispatch(setInitialUrl(landingUrl, searchParams || new URLSearchParams()))

    if (window.location.search) {
      clearUrlSearchParams()
    }
  } else if (state.searchParams && window.location.search) {
    const searchParams = new URL(window.location.href).searchParams

    for (const key of state.searchParams.keys()) {
      searchParams.append(key, state.searchParams.get(key))
    }

    store.dispatch(setSearchParams(searchParams))

    clearUrlSearchParams()
  }

  store.dispatch(changedUrlPath(window.location.pathname))
}
